/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const VolumeMaxIcon = createIcon({
    displayName: 'VolumeMaxIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M7.015 8.007 10.33 4h1.657s.827 3.636.827 8.007c0 4.357-.83 7.993-.83 7.993H10.33l-3.245-3.993H4.667c-.368 0-.667-.325-.667-.727V8.735c0-.402.299-.728.667-.728h2.348Zm1.104 7.16 2.78 3.42c.236-1.366.582-3.837.582-6.58 0-2.76-.346-5.239-.582-6.604L8.043 8.857l-.4.483h-2.31v5.334h2.386l.4.493Zm9.643-7.786-.943.942c1.137 1.137 1.731 2.399 1.72 3.65-.012 1.267-.646 2.542-1.834 3.686l.925.96c1.451-1.398 2.227-3 2.242-4.634.015-1.617-.715-3.21-2.11-4.604Zm-3.277 3.193c.448.45.683.936.679 1.408-.005.48-.256.973-.727 1.426l.925.96c.735-.707 1.127-1.528 1.135-2.374.008-.838-.362-1.655-1.07-2.362l-.942.942Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M12.22 12.01c0-3.78-.52-7.16-.86-8.99h-.01L7 7.85l-.6.66H2.99v7h3.53l.6.67 4.24 4.78c.35-1.83.86-5.17.86-8.95ZM10.93 1h1.26c.48 0 .88.33.98.79.34 1.63 1.06 5.65 1.06 10.22s-.73 8.57-1.07 10.2c-.1.47-.51.79-.98.79h-1.23c-.29 0-.56-.13-.75-.34l-4.57-5.15H3c-1.1 0-2-.9-2-2v-7c0-1.1.9-2 2-2h2.52l4.67-5.18a1 1 0 0 1 .74-.33Zm7.8 5.5c1.7 1.71 2.6 3.6 2.58 5.47-.02 1.9-.97 3.81-2.75 5.53l1.39 1.44c2.18-2.1 3.34-4.5 3.36-6.95.02-2.42-1.07-4.81-3.17-6.91l-1.41 1.41v.01Zm-2.19 9.07.005-.005.005.005h-.01Zm.005-.005c1.097-1.059 1.685-2.287 1.695-3.555.01-1.26-.54-2.48-1.6-3.54l-1.41 1.41c.67.67 1.03 1.4 1.02 2.11 0 .72-.38 1.46-1.09 2.14l1.385 1.435Z",
            clipRule: "evenodd"
        })
    ]
});
VolumeMaxIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'VolumeMaxIcon'
};
export { VolumeMaxIcon };

//# sourceMappingURL=volume-max.js.map